export default 'smsLogsPage';
